import { useMemo } from 'react'
import { GridColDef, GridPinnedColumns, GridRowParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'

export function useDataGridActions<T extends GridValidRowModel>(
  columns: readonly GridColDef<T>[],
  pinnedColumns: GridPinnedColumns | undefined,
  getActions: (params: GridRowParams<T>) => React.ReactElement[]
) {
  const { t } = useTranslation()

  return useMemo(() => {
    const columnsWithActions = columns.concat({
      type: 'actions',
      width: 100,
      field: 'actions',
      getActions,
      headerName: t('global.actions'),
      hideable: false,
      resizable: false,
      disableExport: true
    })

    const right = pinnedColumns?.right ?? []

    const pinnedColumnsWithActions = {
      ...pinnedColumns,
      right: appendActionsColumn(right)
    }

    return { columns: columnsWithActions, pinnedColumns: pinnedColumnsWithActions }
  }, [columns, pinnedColumns, getActions])
}

function appendActionsColumn(pinnedColumns: string[]): string[] {
  if (pinnedColumns.includes('actions')) {
    return pinnedColumns.filter(column => column !== 'actions').concat('actions')
  }

  return pinnedColumns.concat('actions')
}
